var _circle, _circle2, _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutdoorCeremonySpace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.63428,
    cy: 3.81396,
    r: 2.18896,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9019,
    cy: 3.81396,
    r: 2.18896,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19922 5.28516C5.19922 5.28516 8.86929 9.57856 15.1818 9.57856C21.4942 9.57856 25.1643 5.28516 25.1643 5.28516",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33594 9.2207C2.33594 8.66842 2.78365 8.2207 3.33594 8.2207H3.97839C4.53068 8.2207 4.97839 8.66842 4.97839 9.2207V21.4336H2.33594V9.2207Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.582 9.2207C25.582 8.66842 26.0297 8.2207 26.582 8.2207H27.2245C27.7768 8.2207 28.2245 8.66842 28.2245 9.2207V21.4336H25.582V9.2207Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.7129,
    y: 21.4336,
    width: 4.37805,
    height: 2.42188,
    rx: 1,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.46875,
    y: 21.4336,
    width: 4.37805,
    height: 2.42188,
    rx: 1,
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64844 5.80664V8.34375",
    stroke: "black",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9023 5.80664V8.34375",
    stroke: "black",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8471 15.7508C11.8767 15.642 11.9756 15.5664 12.0884 15.5664H18.3891C18.501 15.5664 18.5993 15.6408 18.6297 15.7485L20.8982 23.7876C20.9433 23.9471 20.8234 24.1055 20.6576 24.1055H9.90373C9.73898 24.1055 9.61927 23.9489 9.66248 23.7899L11.8471 15.7508Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoorCeremonySpace);
export default __webpack_public_path__ + "static/media/OutdoorCeremonySpace.1b9ee89d29e45ebcd01db043a42a64a1.svg";
export { ForwardRef as ReactComponent };